import { BrandIconSpinner, Button, UploadFiles } from 'components';
import React, { useEffect, useState } from 'react';
import { Notification } from 'components/CustomNotification';
import { useDispatch, useSelector } from 'react-redux';
import CustomCarousel from 'components/CustomCarousel';
import { AddMoreStyle } from 'pages/addprofile/AddProfile.style';
import {
  addBuinessPlace,
  // getBuinessPlaceList,
  getBusinessImagesList,
} from 'redux/features/BuinessPlaceSlice';
import { ProfileLimit } from 'assert/OptionList';
import { AddBuinessPlaceStyle } from './Buisness.style';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import { Business, imagesDelete } from 'redux/APIEndPoint';
import { useTranslation } from 'react-i18next';
// businessList

export default function BusinessImages({
  handleCancelModal,
  businessImgData,
  ImageEdit,
  autoPlay
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { loading } = useSelector((state) => state.Loading);

  const [image, setImage] = useState([]);

  const handleSubmit = () => {
    const fromData = new FormData();
    fromData.set('businessPageId', businessImgData.id);

    image?.forEach((data) => {
      typeof data !== 'string' && fromData.append('images', data);
    });
    dispatch(SetLoading());
    dispatch(
      addBuinessPlace(
        fromData,
        `${Business}/images`,
        ImageEdit ? 'put' : 'post'
      )
    )
      .then((res) => {
        dispatch(ClearLoading());
        dispatch(getBusinessImagesList(businessImgData.id));
        setImage([]);
        Notification('success', res?.data?.message);
        handleCancelModal();
        // dispatch(getBuinessPlaceList(`${businessList}?page=0&size=10`));
      })
      .catch((err) => {
        dispatch(ClearLoading());
        Notification('warning', err.response?.data?.message);
        handleCancelModal();
      });
  };

  useEffect(() => {
    setImage(businessImgData?.image || []);
  }, [businessImgData]);

  const Deleteitem = (id) => {
    dispatch(SetLoading());
    const payload = {
      businessPageId: businessImgData.id,
      index: [id],
      attachment: [image?.[id]],
    };

    dispatch(addBuinessPlace(payload, imagesDelete, 'delete'))
      .then(() => {
        setImage(
          image?.filter((_, index) => {
            return index !== id;
          })
        );
        dispatch(ClearLoading());
        dispatch(getBusinessImagesList(businessImgData.id));
        Notification('success', 'Deleted Successfully');
      })
      .catch((err) => {
        dispatch(ClearLoading());
        Notification('error', err.response?.data?.message);
      });
  };

  const handleImgUpload = (data) => {
    const imgList = [...image];
    data.forEach((li) => li.size / 1024 ** 2 <= 8 && imgList.length < 8 && imgList.push(li));

    if (data.find((li) => li.size / 1024 ** 2 > 8)) {
      Notification("warning", "Image size should not exceed 8 MB");
    }
    if (data.length > 8) {
      Notification("warning", "You cannot upload more than 8 images");
    }

    setImage(imgList);

  }

  return (
    <AddBuinessPlaceStyle>
      <BrandIconSpinner loading={loading} />
      <AddMoreStyle>
        {image?.length > 0 && (
          <CustomCarousel items={image} handleDelete={(id) => Deleteitem(id)} autoPlay={autoPlay} />
        )}
        <div className="cmy-list-parent-div">
          <UploadFiles
            handleFileSRC={handleImgUpload}
            value={image}
            multiple
            accept={{ 'image/jpeg': ['.jpeg', '.png'] }}
            disabled={image?.length >= ProfileLimit.companyMaxSize}
          />
        </div>
        <div className="modal-footer">
          <Button
            label={t('BusinessPlace.Submit')}
            onClick={handleSubmit}
            type={'text'}
            disabled={!image?.find((data) => {
              return typeof data !== 'string';
            })}
          />
          <Button
            label={t('BusinessPlace.Close')}
            onClick={() => handleCancelModal(false)}
            type={'text'}
          />
        </div>
      </AddMoreStyle>
    </AddBuinessPlaceStyle>
  );
}
